import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onUpdated } from 'vue'
import ru from 'element-plus/es/locale/lang/ru'
import { StatisticAppointmentTypeWithPatients } from '@/shared/types'

interface Props {
  selectedMonthStatistic: StatisticAppointmentTypeWithPatients
}


export default /*#__PURE__*/_defineComponent({
  props: {
    selectedMonthStatistic: null
  },
  setup(__props: any) {

const props = __props as {
  selectedMonthStatistic: StatisticAppointmentTypeWithPatients
}

const getRowClassName = (row: any) => {
  return row.row.date_at_defacto !== '-' ? 'green-row-bold' : 'white-row'
}



return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: _unref(ru) }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        class: "table",
        "row-class-name": getRowClassName,
        "cell-class-name": "white-cell",
        fit: false,
        "max-height": "400",
        data: __props.selectedMonthStatistic.patients,
        style: { width: 'fit-content' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "Имя",
            prop: "name",
            width: "150",
            sortable: ""
          }),
          _createVNode(_component_el_table_column, {
            label: "Фамилия",
            prop: "surname",
            width: "150",
            sortable: ""
          }),
          _createVNode(_component_el_table_column, {
            label: "Отчество",
            prop: "patronymic",
            width: "150",
            sortable: ""
          }),
          _createVNode(_component_el_table_column, {
            label: "Прием",
            prop: "date_at",
            width: "120",
            sortable: ""
          }),
          _createVNode(_component_el_table_column, {
            label: "План",
            prop: "date_at_planned",
            width: "120",
            sortable: ""
          }),
          _createVNode(_component_el_table_column, {
            label: "Фактически",
            prop: "date_at_defacto",
            width: "150",
            sortable: ""
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})